var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.pending)?_c('router-view'):_vm._e(),(_vm.display)?_c('modal-simple',{attrs:{"notClose":_vm.notClose,"label":_vm.label},on:{"close":_vm.close}},[_c(_vm.content,{tag:"component",on:{"close":_vm.close}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }